import React, { useState } from 'react';
import {
    FaExternalLinkAlt,
} from 'react-icons/fa';
import Header from '../components/Header';
import Footer from '../components/Footer';

// Composant pour afficher le drapeau
const CountryFlag = ({ countryCode, alt }) => {
    return (
        <img
            src={`https://flagcdn.com/w160/${countryCode}.png`}
            srcSet={`https://flagcdn.com/w320/${countryCode}.png 2x`}
            alt={alt}
            className="country-flag-img"
        />
    );
};

const Niger = () => {

    const countryData = {
        name: 'Niger',
        countryCode: 'ne',
    };

    // Liste des partenaires avec leurs logos
    const partners = [
        {
            id: 1,
            name: 'ARMP',
            logo: '../assets/images/partenaires/nig1.png',
            
            // url: 'https://pecb.com'
        },
        {
            id: 2,
            name: 'OXFAM Niger',
            logo: '../assets/images/partenaires/nig2.png',
            
            // url: '#'
        },
        {
            id: 3,
            name: 'PIMELAN',
            logo: '../assets/images/partenaires/nig3.png',
            
            // url: '#'
        }
        
    ];

    return (
        <>
            <Header />
            <div className="partners-page-wrapper">
                {/* Hero Section avec Drapeau */}
                <section className="hero-section">
                    <div className="container">
                        <div className="hero-content">
                            <div className="flag-hero-container">
                                <CountryFlag countryCode={countryData.countryCode} alt={`Drapeau ${countryData.name}`} />
                            </div>

                            <h1 className="hero-title">
                                Nos Partenaires au  
                                <span className="highlight">{countryData.name}</span>
                            </h1>

                            <p className="hero-description">
                                Le Niger, terre du légendaire cinéaste Oumarou Ganda et berceau de talents cinématographiques, 
                                perpétue une riche tradition audiovisuelle. Nos partenaires accompagnent le développement 
                                du cinéma nigérien et soutiennent les créateurs dans la valorisation de leur patrimoine culturel 
                                et la production d'œuvres contemporaines.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Grille des Logos Partenaires */}
                <section className="partners-grid-section">
                    <div className="container">
                        <div className="section-header">
                            <h2 className="section-title">Entreprises & Institutions Partenaires</h2>
                        </div>

                        <div className="partners-grid">
                            {partners.map((partner) => (
                                <a
                                    key={partner.id}
                                    href={partner.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="partner-card"
                                >
                                    <div className="partner-logo-container">
                                        <img
                                            src={partner.logo}
                                            alt={partner.name}
                                            className="partner-logo"
                                        />
                                    </div>
                                    <div className="partner-info">
                                        <h3 className="partner-name">{partner.name}</h3>
                                        <span className="partner-category">{partner.category}</span>
                                    </div>
                                    <div className="partner-link-icon">
                                        <FaExternalLinkAlt />
                                    </div>
                                </a>
                            ))}
                        </div>
                    </div>
                </section>
              

                <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .partners-page-wrapper {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
          background: #ffffff;
          margin-top: 40px;
        }

        .container {
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 24px;
        }

        /* Hero Section */
        .hero-section {
          padding: 80px 0 60px;
          background: linear-gradient(180deg, #fafafa 0%, #ffffff 100%);
          text-align: center;
        }

        .hero-content {
          max-width: 800px;
          margin: 0 auto;
        }

        .flag-hero-container {
          display: inline-block;
          width: 180px;
          height: 120px;
          background: white;
          border-radius: 16px;
          padding: 12px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
          margin-bottom: 32px;
        }

        .country-flag-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 10px;
        }

        .hero-title {
          font-size: 48px;
          font-weight: 900;
          color: #1a202c;
          line-height: 1.2;
          margin-bottom: 16px;
          letter-spacing: -1px;
        }

        .highlight {
          background: linear-gradient(135deg, #fd7e14 0%, #198754 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-left: 8px;
        }

        .hero-description {
          font-size: 18px;
          color: #4a5568;
          line-height: 1.7;
          margin-bottom: 48px;
        }

        /* Partners Grid Section */
        .partners-grid-section {
          padding: 80px 0;
          background: white;
          margin-top: -100px;
        }

        .section-header {
          text-align: center;
          margin-bottom: 56px;
        }

        .section-title {
          font-size: 36px;
          font-weight: 900;
          color: #1a202c;
          letter-spacing: -0.5px;
        }

        .partners-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 24px;
        }

        .partner-card {
          position: relative;
          background: white;
          border: 2px solid #e2e8f0;
          border-radius: 16px;
          padding: 32px 24px;
          text-decoration: none;
          display: flex;
          flex-direction: column;
          align-items: center;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .partner-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
          border-color: #fd7e14;
        }

        .partner-logo-container {
          width: 100%;
          height: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
          background: #f7fafc;
          border-radius: 12px;
          padding: 16px;
        }

        .partner-logo {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
        }

        .partner-info {
          text-align: center;
          width: 100%;
        }

        .partner-name {
          font-size: 17px;
          font-weight: 700;
          color: #1a202c;
          margin-bottom: 8px;
          line-height: 1.4;
        }

        .partner-link-icon {
          position: absolute;
          top: 16px;
          right: 16px;
          width: 32px;
          height: 32px;
          background: #f7fafc;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #718096;
          font-size: 14px;
          opacity: 0;
          transition: all 0.3s ease;
        }

        .partner-card:hover .partner-link-icon {
          opacity: 1;
          background: #fd7e14;
          color: white;
        }


        /* Responsive */
        @media (max-width: 768px) {
          .hero-title {
            font-size: 32px;
          }

          .partners-grid {
            grid-template-columns: 1fr;
          }

          .section-title {
            font-size: 28px;
          }

          .cta-card {
            padding: 48px 32px;
          }

          .cta-title {
            font-size: 24px;
          }
        }
      `}</style>
            </div>
            <Footer />
        </>
    );
};

export default Niger;